import request from '@/utils/api/request';
import factory from '@/utils/api/factory';

export const state = () => ({
  projectInfo: null,
});

export const mutations = {
  setProjectInfo(state, info) {
    state.projectInfo = info;
  },
  updateProjectInfo(state, info) {
    state.projectInfo = {
      ...state.projectInfo,
      ...info,
    };
  },
};

export const actions = {
  async loadProjectInfo({ commit, state }, { id, needUpdate = true }) {
    // В переходе в тендер не из проекта требуется инфа из проекта (валюты),
    // но при наличии загруженного проекта не нужно грузить его снова
    if (needUpdate || !state.projectInfo) {
      try {
        const { data } = await request.get(`/projects/${id}/`);
        commit('setProjectInfo', data);
      } catch (e) {
        console.error(e);
      }
    }
  },
  async updateProject({ state, commit }, params) {
    let { data } = await factory('projects').patchInPath(state.projectInfo.id, params);
    commit('updateProjectInfo', data);
  },
  async updateProjectImage({ state, commit, dispatch }, image) {
    try {
      let body = new FormData();
      body.append('image', image);
      const { data } = await request.post(`projects/${state.projectInfo.id}/image/`, body);
      commit('updateProjectInfo', { image: data.image });
    } catch (e) {
      dispatch(
        'alert/showAlert',
        { type: 'error', text: e.response?.data?.image?.[0] || '' },
        { root: true }
      );
    }
  },
  async deleteProjectImage({ state, commit, dispatch }) {
    try {
      await request.delete(`projects/${state.projectInfo.id}/image/`);
      commit('updateProjectInfo', { image: null });
    } catch (e) {
      dispatch('alert/showAlert', { type: 'error' }, { root: true });
    }
  },
};

export default { namespaced: true, state, mutations, actions };
